import { Navigate } from "react-router-dom";
import AdminLogin from "../../authentication/Login";
import Membership from "../../member/Membership";
import AdminRegister from "../../authentication/AdminRegister";
import Register from "../../authentication/Register";
import MembershipForm from "../../authentication/MembershipForm";
import { adminRoutes } from "./AdminRoutes";
import { superAdminRoutes } from "./SuperAdminRoutes";
import { parentAdminRoutes } from "./ParentAdminRoutes";
import NotFound from "../../NotFound/NotFound";

const unauthenticatedRoutes = [
  { path: "/login", element: <AdminLogin /> },
  { path: "/adminlogin", element: <AdminLogin /> },
  { path: "/", element: <Navigate to="/login" replace /> },
  { path: "/admin/*", element: <Navigate to="/login" replace /> },
];

const memberRoutes = [{ path: "/membership", element: <Membership /> }];

const commonRoutes = [
  { path: "/admin/register/:email", element: <AdminRegister /> },
  { path: "/register", element: <Register /> },
  { path: "/:groupName/join", element: <MembershipForm /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export {
  unauthenticatedRoutes,
  memberRoutes,
  commonRoutes,
  adminRoutes,
  superAdminRoutes,
  parentAdminRoutes,
};
